<template>
    <app-modal :modal-id="modalId" :modal-size="modalSize" :modal-alignment="modalAlignment"
        :modal-body-class="'w-full max-w-full wizard-steps'" @close-modal="closeModal">
        <template slot="header">
            <h5 class="modal-title">
                {{ modalTitle }}
                <span v-if="dataMaster && (dataMaster.name || dataMaster.id)" class="text-primary">- {{ dataMaster.name
                    }} ({{ dataMaster.id }})</span>
            </h5>
            <button type="button" class="close outline-none" data-dismiss="modal" aria-label="Close"
                @click.prevent="closeModal">
                <span>
                    <app-icon :name="'x'"></app-icon>
                </span>
            </button>
        </template>

        <template slot="body">
            <app-overlay-loader v-if="preloader" />
            <ul class="nav nav-pills mb-4" id="pills-tab">
                <li class="nav-item" v-for="(tab, index) in tabs" :key="'nav-link' + index">
                    <a class="nav-link"
                        :class="{ 'active': index === currentTabIndex, 'disabled': index !== currentTabIndex }"
                        :id="'pills-' + tab.name + '-tab'" data-toggle="pill" :href="'#' + tab.name + '-' + index"
                        @click="selectedTab(index)">
                        <div class="text-capitalize" :class="[index === 0 ? 'tab-step-init' : 'tab-step']">
                            {{ tab.name }}
                        </div>
                    </a>
                </li>
            </ul>
            <div>
            </div>
            <hr>
            <div class="tab-content" id="pills-tabContent" style="min-height: 200px">
                <!-- <div v-for="(tab, index) in tabs" :key="'tab-pane' + index" class="tab-pane fade"
                    :class="{ 'show active': index === currentTabIndex }" :id="tab.name + '-' + index">
                </div> -->
                <component :is="currentTab.component" v-bind="currentTab.props" v-model="dataCarry[currentTab?.key]"
                    :key="currentTab.key + '-' + currentTabIndex" />
            </div>
        </template>

        <template slot="footer">
            <div enter-class="w-full flex-row justify-content-end" :class="{ 'loading-opacity': preloader }">
                <button v-if="canBack" type="button" class="btn btn-secondary mr-2" @click.prevent="cancel">
                    {{ $t('back') }}
                </button>
                <button type="button" class="btn btn-primary" @click.prevent="submit" :disabled="!enableSubmit">
                    <span v-if="preloader">
                        <app-pre-loader spinner-class="width-19 height-19" />
                    </span>
                    <span v-else-if="currentTabIndex >= tabs.length - 1">
                        {{ $t('submit') }}
                    </span>
                    <span v-else>
                        {{ $t('save') }} & {{ $t('next') }}
                    </span>
                </button>
            </div>
        </template>
    </app-modal>
</template>

<script>
import { ModalMixin } from "../../../../Mixins/ModalMixin";
import { Schema } from "./ProductApprovalFormWizardScheme";
import { NEW_COURSE, PRODUCT, STUDENT, CLC_CALENDAR, PRODUCT_APPROVAL, PACKAGES_HISTORY } from "../../../../Config/ApiUrl";

const ProductApprovalOverview = () => import("./ProductApprovalOverview.vue");
const ProductApprovalNextStepOptions = () => import("./ProductApprovalNextStepOptions.vue");
const ProductApprovalSelectOneTable = () => import("./ProductApprovalSelectOne.vue");
const ProductFormWithoutModal = () => import("../../Master/Product/FormWithoutModal.vue");
const NewCourseFormWithoutModal = () => import("../../Transaction/NewCourse/FormWithoutModal.vue");

export default {
    name: "ProductApprovalFormWizard",
    mixins: [Schema, ModalMixin],
    mounted() {
        window.__selectProductAndPackage = this.onSelectProductAndPackage;
        this.currentTabIndex = this.tabInit;
        this.currentComponentName();
    },
    created() {
        this.tabs = [
            // Index 0
            {
                key: 'lead',
                name: 'Student List',
                component: ProductApprovalSelectOneTable,
                props: {
                    tableId: `${this.formWizardId}-student-list-table`,
                    selectedUrl: `${STUDENT}?per_page=50`,
                    tableColumns: [
                        {
                            title: "Report?",
                            type: "text",
                            key: "id",
                            modifier: (value) => {
                                return '-';
                            },
                        },
                        {
                            title: "CLC ID No",
                            type: "custom-html",
                            key: "clc_id_number",
                            modifier: (value, row) => {
                                return row?.student_id || row?.lead_id_number || row?.clc_id_number || "-";
                            },
                        },
                        {
                            title: "Full Name",
                            type: "text",
                            key: "full_name",
                        },
                        {
                            title: "School",
                            type: "custom-html",
                            key: "school",
                            modifier: (value) => {
                                return value?.name;
                            },
                        },
                        {
                            title: "School Level",
                            type: "custom-html",
                            key: "school_level",
                            modifier: (value) => {
                                return value?.name;
                            },
                        },
                    ],
                },
                onInit: (thisTab) => {
                    const tabKey = thisTab.key;
                    this.currentTabSubmitEvent = () => {
                        this.resetCurrentTabEvent();
                        if (this.dataCarry[tabKey]?.id) {
                            this.preloader = true;
                            this.axiosGet(`${PACKAGES_HISTORY}/latest?clc_id_number=${this.dataCarry[tabKey]?.clc_id_number}`)
                                .then((res) => {
                                    if (res.data) {
                                        this.dataMaster = {
                                            ...this.dataMaster,
                                            product: res.data.product,
                                            packages: res.data.package,
                                        };
                                        console.log(this.dataMaster);
                                    }
                                })
                                .catch((res) => {
                                    this.$toastr.e(res.data.message);
                                })
                                .finally(() => {
                                    this.preloader = false;
                                });
                        }
                    };
                },
            },
            // Index 1
            {
                key: 'product',
                name: 'Product',
                component: ProductApprovalNextStepOptions,
                props: {
                    formId: `${this.formWizardId}-product-selection-form`,
                    options: () => {
                        let options = [
                            // Existing Product Selection
                            {
                                key: "existing-product-selection",
                                buttonLabel: "Select existing product",
                                selectedUrl: `${PRODUCT}?include_list_packages=1&product_category_exclude=3,2&is_active=1&per_page=50`,
                                tableColumns: [
                                    {
                                        title: this.$t("product_category"),
                                        type: "object",
                                        key: "product_category",
                                        modifier: (v) => {
                                            return v ? v.name : "";
                                        },
                                    },
                                    {
                                        title: this.$t("name"),
                                        type: "text",
                                        key: "name",
                                    },
                                    {
                                        title: this.$t("description"),
                                        type: "text",
                                        key: "description",
                                    },
                                    {
                                        title: this.$t("price"),
                                        type: "custom-html",
                                        key: "price",
                                        modifier: (value) => {
                                            return this.formattedIDR(value) ? this.formattedIDR(value) : this.formattedIDR(0);
                                        },
                                    },
                                ],
                                onClick: () => {
                                    this.dataCarry[this.currentTab?.key] = null;
                                    if (this.skippedTabIndexes.includes(2)) this.skippedTabIndexes = this.skippedTabIndexes.filter(e => e != 2);
                                    if (!this.skippedTabIndexes.includes(3)) this.skippedTabIndexes.push(3);
                                },
                            },
                            // Create New Product
                            {
                                key: "create-new-product",
                                buttonLabel: "Create new product",
                                component: ProductFormWithoutModal,
                                props: {
                                    tableId: "new-product-form-table",
                                    formId: `${this.formWizardId}-new-product-form`,
                                    rowData: this.dataCarry[this.currentTab?.key] ? { clc_id_number: this.dataCarry['lead']?.clc_id_number, ...this.dataCarry[this.currentTab?.key] } : { clc_id_number: this.dataCarry['lead']?.clc_id_number },
                                },
                                onClick: () => {
                                    this.currentTabSubmitEvent = () => {
                                        this.resetCurrentTabEvent();
                                        if (option.componentRef && typeof option.componentRef.submit == 'function') {
                                            option.componentRef.submit();
                                        }
                                    };
                                    this.dataCarry[this.currentTab?.key] = {};
                                    if (!this.skippedTabIndexes.includes(2)) this.skippedTabIndexes.push(2);
                                    if (this.skippedTabIndexes.includes(3)) this.skippedTabIndexes = this.skippedTabIndexes.filter(e => e != 3);
                                },
                            },
                        ];
                        if (typeof this.dataMaster.product === "object") {
                            options = [
                                // Last Product Overview
                                {
                                    key: 'last-product-overview',
                                    buttonLabel: 'Last Product',
                                    component: ProductApprovalOverview,
                                    hideSearchBar: true,
                                    props: {
                                        formId: `${this.formWizardId}-last-product`,
                                        rowData: () => ({
                                            product: {
                                                ...this.mapProductToOverview(this.dataMaster.product),
                                                list_packages: this.mapPackagesToOverview(this.dataMaster.packages),
                                            },
                                        }),
                                        rowData: () => {
                                            let mappedProduct = this.mapProductToOverview(this.dataMaster.product);
                                            if (typeof this.dataMaster.packages === "object") {
                                                mappedProduct = {
                                                    product: {
                                                        ...mappedProduct,
                                                        list_packages: this.mapPackagesToOverview(this.dataMaster.packages),
                                                    },
                                                };
                                            }
                                            return mappedProduct;
                                        },
                                    },
                                    onClick: () => {
                                        this.dataCarry['product'] = this.dataMaster.product;
                                        this.dataCarry['packages'] = this.dataMaster.packages;
                                        if (this.skippedTabIndexes.includes(2)) this.skippedTabIndexes = this.skippedTabIndexes.filter(e => e != 2);
                                        if (!this.skippedTabIndexes.includes(3)) this.skippedTabIndexes.push(3);
                                    },
                                },
                                ...options,
                            ];
                        }
                        return options;
                    },
                    canSubmit: (status) => this.enableSubmit = status,
                },
                onInit: (thisTab) => {
                    const tabKey = thisTab.key;
                    this.currentTabSubmitEvent = () => {
                        this.resetCurrentTabEvent();
                        if (this.dataCarry[tabKey]?.id) {
                            this.preloader = true;
                            this.axiosGet(`${PRODUCT}/${this.dataCarry[tabKey].id}`)
                                .then((res) => {
                                    if (res.data) {
                                        this.dataCarry[tabKey] = res.data;
                                        // console.log(res.data);
                                    }
                                })
                                .catch((res) => {
                                    this.$toastr.e(res.data.message);
                                })
                                .finally(() => {
                                    this.preloader = false;
                                });
                        }
                    };
                },
            },
            // Index 2
            {
                key: 'packages',
                name: 'Package',
                component: ProductApprovalSelectOneTable,
                props: {
                    tableId: `${this.formWizardId}-list-packages-table`,
                    rowData: () => this.dataCarry['product']?.list_packages ?? [],
                    tableColumns: [
                        {
                            title: "Package Name",
                            type: "text",
                            key: "package_name",
                        },
                        {
                            title: "Available Course",
                            type: "custom-html",
                            key: "course_list_packages",
                            modifier: (value) => {
                                return value && Array.isArray(value) ? value.map(clp => `${clp.course.course_name} (${clp.course.course_date_clc_start} - ${clp.course.course_date_clc_end})`).join(', ') : '';
                            },
                        },
                    ],
                },
            },
            // Index 3
            {
                key: 'class',
                name: 'Class',
                component: ProductApprovalNextStepOptions,
                props: {
                    formId: `${this.formWizardId}-new-course-selection-form`,
                    options: [
                        {
                            key: "move-to-create-new-course",
                            buttonLabel: "Move to new class",
                            component: NewCourseFormWithoutModal,
                            props: {
                                tableId: "new-course-form-table",
                                formId: `${this.formWizardId}-new-course-form`,
                                rowData: this.dataCarry[this.currentTab?.key] ? { clc_id_number: this.dataCarry['lead']?.clc_id_number, ...this.dataCarry[this.currentTab?.key] } : { clc_id_number: this.dataCarry['lead']?.clc_id_number },
                                // onAfterSubmit: (status, res) => { console.log(`onAfterSubmit.${status}:`, res); },
                            },
                            onClick: () => { },
                        },
                        {
                            key: "move-to-existing-course-selection",
                            buttonLabel: "Move to existing class",
                            selectedUrl: `${NEW_COURSE}?is_active=1&per_page=50`,
                            multipleSelection: true,
                            tableColumns: [
                                {
                                    title: "Center",
                                    type: "custom-html",
                                    key: "center",
                                    isVisible: true,
                                    modifier: (value) => {
                                        return value ? value.name : '-'
                                    },
                                },
                                {
                                    title: "Class Name",
                                    type: "text",
                                    key: "course_name",
                                },
                                {
                                    title: "Teacher",
                                    type: "custom-html",
                                    key: "teacher",
                                    isVisible: true,
                                    modifier: (value) => {
                                        return value ? value.full_name : '-'
                                    },
                                },
                                {
                                    title: "Side Teacher",
                                    type: "custom-html",
                                    key: "side_teacher",
                                    isVisible: true,
                                    modifier: (value) => {
                                        return value ? value.full_name : '-'
                                    },
                                },
                                {
                                    title: "Trainer Teacher",
                                    type: "custom-html",
                                    key: "trainer_teacher",
                                    isVisible: true,
                                    modifier: (value) => {
                                        return value ? value.full_name : '-'
                                    },
                                },
                                {
                                    title: "Day",
                                    type: "text",
                                    key: "day",
                                },
                                {
                                    title: "CLC Start",
                                    type: "text",
                                    key: "course_date_clc_start",
                                },
                                {
                                    title: "CLC End",
                                    type: "text",
                                    key: "course_date_clc_end",
                                },
                            ],
                            onClick: () => { },
                        },
                    ],
                    canSubmit: (status) => this.enableSubmit = status,
                },
            },
            // Index 4
            {
                key: 'academic_calendar',
                name: 'Semester',
                component: ProductApprovalSelectOneTable,
                props: {
                    tableId: `${this.formWizardId}-academic-table`,
                    selectedUrl: CLC_CALENDAR,
                    tableColumns: [
                        {
                            title: "Academic Calendar",
                            type: "text",
                            key: "academic_calendar_name",
                        },
                        {
                            title: "Date Start",
                            type: "text",
                            key: "date_start",
                        },
                        {
                            title: "Date End",
                            type: "text",
                            key: "date_end",
                        },
                    ],
                },
            },
            // Last Index
            {
                key: 'overview',
                name: 'Overview',
                component: ProductApprovalOverview,
                props: {
                    formId: `${this.formWizardId}`,
                },
                onInit: (thisTab) => {
                    const tabKey = thisTab.key;
                    const selectedUrl = PRODUCT_APPROVAL;
                    this.mapDataCarryToOverview();
                    const mappedOverview = this.mapOverviewToJson(this.dataCarry[tabKey]);
                    console.log(`submitData[${selectedUrl}].dataCarry:`, mappedOverview);
                    this.currentTabSubmitEvent = () => {
                        this.resetCurrentTabEvent();
                        this.enableSubmit = false;
                        this.preloader = true;
                        this.axiosPost({ url: selectedUrl, data: mappedOverview })
                            .then((res) => {
                                // console.log(res);
                            })
                            .catch((res) => {
                                console.error(res);
                                this.$toastr.e(res.data.message);
                            })
                            .finally(() => {
                                this.closeModal();
                                this.preloader = false;
                                this.$hub.$emit("reload-" + this.tableId);
                            });
                    };
                },
            },
        ];
        this.enableSubmit = false;
        this.dataCarry = Object.fromEntries(this.tabs.map(t => [t.key, null]));
    },
    watch: {
        dataCarry: {
            deep: true,
            handler(newVal) {
                // console.log("Child updated dataCarry:", newVal);
                this.enableSubmit = this.dataCarry[this.currentTab?.key];

                // Set first dataCarry as dataMaster
                if (this.enableSubmit && this.dataMaster == null) {
                    const dataLead = this.dataCarry[this.tabs[0].key];
                    this.dataMaster = {
                        name: dataLead?.full_name ?? (dataLead?.name),
                        id: dataLead?.clc_id_number ?? dataLead?.lead_id_number,
                    };
                }
            },
        },
    },
};
</script>
